@if (client._id) {
  <div class="modal fade" id="add-contract-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add contract</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #addContractForm="ngForm">
            <div class="form-group">
              <label>Contract <span class="text-danger small">(required)</span></label>
              <select class="form-control" name="contract" [(ngModel)]="newContract.name" required>
                <option value="" selected disabled>Select contract</option>
                @for (contract of contracts; track contract) {
                  <option [value]="contract">{{contract}}</option>
                }
              </select>
            </div>
            <div class="form-group">
              <label>Start date <span class="text-danger small">(required)</span></label>
              <input type="date" class="form-control" name="startDate" [(ngModel)]="newContract.startDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
            </div>
            <div class="form-group">
              <label>End date <span class="text-danger small">(required)</span></label>
              <input type="date" class="form-control" name="endDate" [(ngModel)]="newContract.endDate" [pattern]="dateRegexp" placeholder="YYYY-MM-DD" required>
            </div>
            <div class="form-group">
              <label>Automatic renewal <span class="text-danger small">(required)</span></label>
              <select class="form-control" name="autorenewal" [(ngModel)]="newContract.autorenewal" required>
                <option value="" selected disabled>Select automatic renewal</option>
                <option [value]="true">Yes</option>
                <option [value]="false">No</option>
              </select>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
            [disabled]="!addContractForm.form.valid"
            (click)="addArrayField()">
            <i class="fa fa-plus-circle"></i> Add contract
          </button>
        </div>
      </div>
    </div>
  </div>
}